import React, {useEffect, useState} from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';

export default function LoginForm() {
   const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    mac: "",
    password: "",
  });
  const navigate = useNavigate();
  const location = useLocation();

  // Regex for MAC address validation
  const macRegex = /^([0-9A-Fa-f]{2}:){7}[0-9A-Fa-f]{2}$/;

  // Automatically format MAC address
  const formatMacAddress = (value) => {
    // Remove all non-hexadecimal characters
    const sanitizedValue = value.replace(/[^0-9A-Fa-f]/g, "");

    // Insert colons every two characters
    const formattedValue = sanitizedValue
        .match(/.{1,2}/g) // Split into groups of 2 characters
        ?.join(":") // Join with colons
        .substring(0, 23) || ""; // Limit to 17 characters (XX:XX:XX:XX:XX:XX)

    return formattedValue;
  };



  // Handler for input field changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    let formattedValue = value;

    // If editing the MAC address, format it
    if (name === "mac") {
      formattedValue = formatMacAddress(value);
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: formattedValue,
    }));

    // Reset error message
    setError("");
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);



    // Prepare form data
    const data = {
      ...formData,
    };

    try {
      const response = await axios.post("https://api.zplayer.app/api/v1/login", data);

      const result = response.data;
      if (result.success) {
        localStorage.setItem('deviceZplayer', JSON.stringify(result.payload));
        localStorage.setItem('authTokenZplayer', JSON.stringify(result.result));
        localStorage.setItem('deviceZplayerPass', data.password);

        setError("");
        toast.success("✅ login device successfully!");
        navigate('/device');  // Replace '/device' with your actual route
      } else {
        setError("Failed to submit the form. Please try again.");
        toast.error("❌ Submission failed. Try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onSubmitLogin = async ({ mac:mac, password:password }) => {
     setLoading(true);



    // Prepare form data
    const data = {
      ...{ mac:mac, password:password },
    };

    try {
      const response = await axios.post("https://api.zplayer.app/api/v1/login", data);

      const result = response.data;
      if (result.success) {
        localStorage.setItem('deviceZplayer', JSON.stringify(result.payload));
        localStorage.setItem('authTokenZplayer', JSON.stringify(result.result));
        localStorage.setItem('deviceZplayerPass', data.password);

        setError("");
        toast.success("✅ login device successfully!");
        navigate('/device');  // Replace '/device' with your actual route
      } else {
        setError("Failed to submit the form. Please try again.");
        toast.error("❌ Submission failed. Try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mac = params.get("mac");
    const password = params.get("password");

    if (mac && password) {
      setFormData({ mac:mac, password:password });
      onSubmitLogin({ mac:mac, password:password }); // Trigger login automatically
    }
  }, [location.search]);
  return (
      <div>
        {/* ToastContainer to display toast notifications */}
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false}/>
        <form id="contact-form" onSubmit={onSubmit}>
          <div className="row gx-3 gy-4">
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">MAC Address</label>
                <input
                    name="mac"
                    placeholder="XX:XX:XX:XX:XX:XX"
                    className="form-control"
                    type="text"
                    value={formData.mac}
                    onChange={handleInputChange}
                    required
                />
                {error && !loading && <small className="text-danger">{error}</small>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Password</label>
                <input
                    name="password"
                    placeholder="Password *"
                    className="form-control"
                    type="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="send">
                <button
                    className={`px-btn w-100 ${loading ? "disabled" : ""}`}
                    type="submit"
                    disabled={loading}
                >
                  {loading ? "Sending..." : "Login"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
        );
        }
